// extracted by mini-css-extract-plugin
export var buttonContainer = "Text-module--buttonContainer--42ebe";
export var center = "Text-module--center--e2664";
export var container = "Text-module--container--6be0e";
export var content = "Text-module--content--ae553";
export var header = "Text-module--header--98e39";
export var headline = "Text-module--headline--45f1c";
export var label = "Text-module--label--9fd77";